import { Component, ojs, app, payload } from "modular-openscriptjs";
import { either } from "../../../helpers";

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");

export default class ErrandNameView extends Component {
	render(productState, ...args) {
		let product = productState.value;

		if (!product?.id) return h.empty();

		let user = product?.owner;

		if (product?.is_copied) {
			user = product?.copier;
		}

		return h.div(
			{
				class: "d-flex p-0 gap-0 position-relative flex-column justify-content-between",
				data_product_id: product?.id,
				$data_product_id: product?.id,
			},

			h.div(
				{
					class: "d-flex py-3 ps-2 pe-3 gap-2 justify-content-between",
				},
				h.div(
					{
						role: "button",
					},
					h.MoreOptions([
						h.span(
							{ class: "text-secondary p-2" },
							h.i({ class: "fas fa-ellipsis-vertical" })
						),
						h.ul(
							{ class: "list-unstyled m-0" },

							either(product.owner_id == gc.user?.id, () =>
								h.li(
									h.div(
										{
											role: "button",
											class: "dropdown-item btn-icon-text gap-1",
											onclick: this.method("copyErrand", [
												product,
												user?.id,
											]),
											title: "Copy Errand",
										},
										h.span(
											{
												class: "text",
											},
											"Copy & Edit"
										),
										h.span(
											{
												class: "icon",
											},
											h.i({
												class: "fa-solid fa-copy",
											})
										)
									)
								)
							),
							either(
								product.owner_id != gc.user?.id &&
									product.is_copyable == 1,
								() =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item btn-icon-text gap-1",
												onclick: this.method(
													"copyErrand",
													[product, user?.id]
												),
												title: "Clone Product",
											},
											h.span(
												{
													class: "text",
												},
												"Copy & Edit"
											),
											h.span(
												{
													class: "icon",
												},
												h.i({
													class: "fa-solid fa-copy",
												})
											)
										)
									)
							),
							either(
								product.is_private == 0 ||
									(gc.user.id == user?.id &&
										product.owner_id == gc.user.id &&
										product.pivot?.user_id == user?.id),
								() => [
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item btn-icon-text gap-1",
												title: "Share on WhatsApp",
												onclick: this.method(
													"shareProduct",
													product
												),
											},
											h.span(
												{
													class: "text text-success",
												},
												"Share"
											),
											h.span(
												{
													class: "icon text-success",
												},
												h.i({
													class: "fa-brands fa-whatsapp",
												})
											)
										)
									),

									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item btn-icon-text gap-1",
												title: "Share on WhatsApp",
												onclick: this.method(
													"showQrCode",
													product
												),
											},
											h.span(
												{ class: "text" },
												"Share (QR)"
											),
											h.span(
												{ class: "icon" },
												h.i({
													class: "fas fa-qrcode",
												})
											)
										)
									),
								]
							),

							either(
								(!app("router").is("user.view-cart") &&
									product.owner_id == gc.user?.id &&
									product.pivot?.user_id == gc.user?.id) ||
									(gc.user?.id == product.pivot?.user_id &&
										gc.user?.id == user?.id &&
										product.parent_product != null),
								() =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item dropdown-item-danger btn-icon-text gap-1",
												title: "Delete Product",
												onclick: this.method(
													"deleteErrand",
													product
												),
											},
											h.span({ class: "text" }, "Delete"),
											h.span(
												{ class: "icon" },
												h.i({
													class: "fa-solid fa-trash-can",
												})
											)
										)
									)
							)
						),
					])
				),

				h.div(
					{ class: "d-flex flex-column" },

					h.div(
						{
							class: "small cursor-pointer d-flex gap-2 align-items-center",
							role: "button",
							onclick: h.func(
								`app("router").to`,
								"product.view-product",
								{
									productId: product?.id,
									u: user?.id,
								}
							),
						},

						h.span(
							h.img({
								width: "100%",
								height: "100%",
								style: "max-width: 30px;",
								src: `/assets/images/errands.png`,
							})
						),

						h.span(
							h.call(() =>
								either(
									product?.name == "Errand",
									product?.errand_type
										?.split("_")
										.map(
											(word) =>
												word.charAt(0).toUpperCase() +
												word.slice(1)
										)
										.join(" "),
									product?.name
								)
							)
						)
					),

					h.div(
						{
							class: "fs-xsm fst-italic text-secondary text-nowrap",
							onclick: h.func(
								`app("router").to`,
								"product.view-product",
								{
									productId: product?.id,
									u: user?.id,
								}
							),
						},
						"by ",
						h.span(
							{ class: "me-2" },
							either(
								user?.display_name?.length > 10,
								user?.display_name?.substring(0, 9) + "...",
								user?.display_name
							),
							" - ",
							h.span(
								product?.errand_information?.length,
								" ",
								"tasks"
							)
						)
					)
				),

				h.div(
					{
						class: "",
					},
					h.button(
						{
							class: "btn text-primary circle border d-flex shadow-sm animated animated-add",
							onclick: this.method("requestErrand", [
								product,
								user?.id,
							]),
						},

						h.span(
							{ class: "d-inline-block lh-1 mt-1 p-0" },
							h.i({ class: "fas fa-list-check" })
						)
					)
				)
			),
			...args
		);
	}

	requestErrand(product, userId) {
		product.original_product_id = product.id;
		broker.send(
			$e.errand.needs.creation,
			payload({ item: product, userId })
		);
	}

	copyErrand(product, userId) {
		product.original_product_id = product.id;
		broker.send(
			$e.errand.needs.creation,
			payload({ item: product, userId })
		);
	}

	deleteErrand(product) {
		broker.send($e.product.needs.deletion, payload({ id: product.id }));
	}

	shareProduct(product) {
		broker.send(
			$e.product.needs.share,
			payload({ id: product.id, product })
		);
	}

	like(product) {
		broker.send($e.product.needs.like, payload({ product }));
	}

	unlike(product) {
		broker.send($e.product.needs.unlike, payload({ product }));
	}

	showQrCode(product) {
		broker.send(
			$e.qr.needs.code,
			payload({
				title: `${product.name} - Item QR Code`,
				data: `/products/${product?.id}/view`,
			})
		);
	}
}

ojs(ErrandNameView);
